// O tema é escrito no <html> como `data-theme`, porque é dele que as 522 linhas
// de CSS portadas dependem (`:root[data-theme="dark"]`). A chave `ce-theme`
// também é contrato com quem já usa o painel: o dev que trabalha no escuro não
// pode acordar no claro no dia do corte.
import { useCallback, useEffect, useState } from 'react';

export type Tema = 'light' | 'dark';
export const CHAVE_TEMA = 'ce-theme';

export const temaGuardado = (): Tema =>
  (localStorage.getItem(CHAVE_TEMA) === 'dark' ? 'dark' : 'light');

/**
 * Aplica antes do primeiro paint, chamado do main.tsx fora do React.
 *
 * Dentro de um efeito seria tarde: o React monta depois do paint, e o painel
 * piscaria branco a cada carga para quem usa o tema escuro. É o mesmo motivo do
 * IIFE no topo do app.js antigo (linha 12).
 */
export function aplicarTemaGuardado(): void {
  document.documentElement.setAttribute('data-theme', temaGuardado());
}

export function useTema(): { tema: Tema; alternar: () => void } {
  const [tema, setTema] = useState<Tema>(temaGuardado);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', tema);
    localStorage.setItem(CHAVE_TEMA, tema);
  }, [tema]);

  const alternar = useCallback(() => setTema((t) => (t === 'dark' ? 'light' : 'dark')), []);
  return { tema, alternar };
}
